<template>
  <div>
    <m-form modal-id="add-login" v-if="user.admin">
      <div slot="title">Add Login</div>
      <div slot="form">
        <div slot="form">
          <div class="form-group">
            <div class="row">
              <div class="col-lg-4">Username</div>
              <div class="col-lg-8">
                <input type="text" class="form-control" v-model="loginModal['username']">
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4">Password</div>
              <div class="col-lg-8">
                <input type="text" class="form-control" v-model="loginModal['password']">
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4">
                <button class="btn btn-xs btn-primary" @click="saveLogin">Save</button>
              </div>
            </div>
          </div>
      </div>
      </div>
    </m-form>
    <m-form modal-id="register-staging" v-if="user.admin">
      <div slot="title">Register Staging</div>
      <div slot="form">
        <div slot="form">
          <div class="form-group">
            <div class="row">
              <div class="col-lg-4">Domain</div>
              <div class="col-lg-8">
                <input type="text" class="form-control" v-model="regStageModal['domain']">
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4">Path</div>
              <div class="col-lg-8">
                <input type="text" class="form-control" v-model="regStageModal['path']">
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4">
                <button class="btn btn-xs btn-primary" @click="saveStageData">Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </m-form>
    <div class="col-lg-4">
      <table class="table table-striped">
        <thead v-if="site.software === 'wordpress'">
        <tr>
          <th colspan="2">
            <span v-if="user.admin">
            <button class="btn btn-primary btn-xs pull-right m-l-xs" @click="purgeCache()"><i class="fas fa-recycle"></i> Purge Cache</button>
            <button class="btn btn-danger btn-xs pull-right m-l-xs" v-if="user.admin && site.logins && site.logins.length && site.accessible" @click="reportIssue('login', 'Login issue')"><i class="fa fa-warning"></i> Login issue</button>
            <button class="btn btn-primary btn-xs pull-right m-l-xs" @click="adminLogin('prod')"><i class="fas fa-user-lock"></i> Admin Login</button>
            <button class="btn btn-primary btn-xs pull-right" v-if="user.admin" data-toggle="modal" data-target="#add-login"><i class="fa fa-user-plus"></i> Add User</button>
            </span>
            <span v-else>
            <button class="btn btn-primary btn-xs pull-right m-l-xs" @click="adminLogin('prod')"><i class="fas fa-user-lock"></i> Admin Login</button>
            </span>
            Production
          </th>
        </tr>
        </thead>
        <tbody  v-if="site.logins" v-for="login in site.logins" :key="login.username">
        <tr>
          <td>User</td>
          <td>
            <pass>
              <span slot="visible">
                {{ login.username }}
                <a><i class="fa fa-remove red" @click="removeLogin(login.username)" v-if="user.admin"></i></a>
                <a><i class="fa fa-copy copy-clipboard pull-right" @click="copyToClipboard(login.username)"></i></a>
              </span>
            </pass>
          </td>
        </tr>
        <tr>
          <td>Password</td>
          <td>
            <pass>
              <span slot="visible">
                {{ login.password }}
                <a><i class="fa fa-copy copy-clipboard pull-right" @click="copyToClipboard(login.password)"></i></a>
              </span>
            </pass>
          </td>
        </tr>
        </tbody>
        <thead>
        <tr>
          <th colspan="2">
            Staging
            <button class="btn btn-primary btn-xs pull-right m-l-xs"
                    @click="createStaging" v-if="!site.staging || !site.staging.domain && user.admin"
            ><i class="fas fa-tools"></i> Set up</button>
            <button
              v-if="site.staging && site.staging.domain"
              class="btn btn-primary btn-xs pull-right m-l-xs"
              @click="adminLogin('stage')"
            ><i class="fas fa-user-lock"></i> Admin Login</button>
            <button v-else-if="user.admin" class="btn btn-xs btn-primary pull-right m-l-xs" data-toggle="modal" data-target="#register-staging"> <i class="fas fa-edit"></i> Register Staging</button>
            <button class="btn btn-danger btn-xs pull-right"
                    @click="createStaging(true)"
                    v-if="(user.id === '6163160e757197395775b0f6' || user.id === '62468b3eb6210f022e2c9172' || user.id === '63f3543a24c6881ae57021d7') && site.staging && site.staging.domain"
            ><i class="fa fa-recycle"></i> Reinstall WP</button>
          </th>
        </tr>
        </thead>
        <tbody v-if="(user.admin  || user.roles.length) && site.staging && site.staging.domain">
        <tr>
          <td>stageuser</td>
          <td>h1dem3stagpass!</td>
        </tr>
        <tr>
          <td>Url</td>
          <td v-if="site.staging && site.staging.domain">
            <a :href="'https://stageuser:h1dem3stagpass!@' + site.staging.domain" target="_blank">{{ site.staging.domain }}</a>
            <a><i class="fa fa-copy copy-clipboard pull-right" @click="copyToClipboard('https://' + site.staging.domain + '\t' + site.staging.username + '\t' + site.staging.password)"></i></a>
            <a v-if="site.staging.username"><i class="fa fa-upload pull-right" title="Add login data to production" @click="saveLogin(site.staging.username, site.staging.password)" v-if="user.admin"></i></a>
            <a :href="'https://stageuser:h1dem3stagpass!@' + site.staging.domain + '/wp-admin'" target="_blank" class=""><i class="fa fa-lock"></i></a>
          </td>
        </tr>
        <tr v-if="site.staging && site.staging.username">
          <td>User</td>
          <td>
            <pass>
              <span slot="visible">
                {{ site.staging.username }}
                <a><i class="fa fa-copy copy-clipboard pull-right" @click="copyToClipboard(site.staging.username)"></i></a>
              </span>
            </pass>
          </td>
        </tr>
        <tr v-if="site.staging && site.staging.username">
          <td>Pass</td>
          <td>
            <pass>
              <span slot="visible">
                {{ site.staging.password }}
                <a><i class="fa fa-copy copy-clipboard pull-right" @click="copyToClipboard(site.staging.password)"></i></a>
              </span>
            </pass>
          </td>
        </tr>
        </tbody>
      </table>
      <table class="table table-striped" v-if="site.software === 'archivarix'">
        <thead>
        <tr>
          <th colspan="2">Production</th>
        </tr>
        <tr>
          <td colspan="2">
            <a :href="`https://apharch:Y2k0gOdrbAza6ai@${site.punyDomain}/manager.php`" target="_blank">https://{{ site.domain }}/manager.php</a>
          </td>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td colspan="2"><strong>Basic auth</strong></td>
        </tr>
        <tr>
          <td>
            <pass>
              <a slot="visible" @click="copyToClipboard('apharch')">
                apharch <i class="fa fa-copy copy-clipboard pull-right"></i>
              </a>
            </pass>
            </td>
          <td>
            <pass>
              <a slot="visible" @click="copyToClipboard('Y2k0gOdrbAza6ai')">
                Y2k0gOdrbAza6ai <i class="fa fa-copy copy-clipboard pull-right"></i>
              </a>
            </pass>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <strong>CMS Password</strong>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <pass>
              <a slot="visible" @click="copyToClipboard('HedAeUs3L3M2mG8')">
                HedAeUs3L3M2mG8 <i class="fa fa-copy copy-clipboard pull-right"></i>
              </a>
            </pass>
          </td>
        </tr>
        </tbody>
      </table>
      <table class="table table-hover" v-if="site.comments">
        <thead>
        <tr>
          <th colspan="2">Log <small>({{ site.comments.length > 10 ? 10 : site.comments.length }}/{{ site.comments.length }})</small></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(c, i) in site.comments.slice().reverse()" :key="'comment-' + i" v-if="i < 10">
          <td class="reversed">
            <div class="col-lg-12">
              <span v-if="c.user"><b>{{ c.user.username }}</b> @ </span>
              <small>{{ c.time.date | aTime('DD.MM. HH:mm') }}</small>
            </div>
            <div class="col-lg-12">{{ c.message }}</div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="col-lg-4">
      <table class="table table-striped" v-if="user.admin">
        <thead>
        <tr>
          <th colspan="2">Registrar</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td colspan="2">
            <e-txt
              type="select"
              :text="site.registrar ? site.registrar.name : ''"
              :options="f.registrars"
              select-value="id"
              select-label="name"
              :selected-value="site.registrar ? site.registrar.id : ''"
              :close-on-save="true"
              @input="updatePbn($event, 'registrar')"
            ></e-txt>
          </td>
        </tr>
        </tbody>
        <tbody v-if="site.registrar">
        <tr>
          <td>Url</td>
          <td><a :href="site.registrar.login.url" target="_blank">{{ shorten(site.registrar.login.url, 50) }}</a></td>
        </tr>
        <tr>
          <td>User</td>
          <td>
            <pass>
              <span slot="visible">
                {{ site.registrar.login.user }} <i class="fa fa-copy copy-clipboard pull-right" @click="copyToClipboard(site.registrar.login.user)"></i>
              </span>
            </pass>
          </td>
        </tr>
        <tr>
          <td>Password</td>
          <td>
            <pass>
              <span slot="visible">
              {{ site.registrar.login.pass }} <i class="fa fa-copy copy-clipboard pull-right" @click="copyToClipboard(site.registrar.login.pass)"></i>
              </span>
            </pass>
          </td>
        </tr>
        </tbody>
      </table>
      <table class="table table-striped" v-if="user.admin || user.roles.includes('ppc')">
        <thead>
        <tr>
          <th colspan="2">IP Provider</th>
        </tr>
        </thead>
        <tbody v-if="site.ipProvider && site.integrations.ip">
        <tr>
          <td colspan="2">
            {{ site.ipProvider.name }}
            <i class="fa fa-remove red pull-right pointer" v-tooltip="'Remove CF'" @click="removeCf"></i>
            <img :src="'/static/img/' + site.ipProvider.integration + '.png'" :alt="site.ipProvider.integration" style="max-height: 12px;" class="pull-right" v-tooltip="site.ipProvider.integration">
          </td>
        </tr>
        <tr>
          <td>
            Status
          </td>
          <td>
            <span class="label label-primary" v-if="site.integrations.ip.status === 'active'"><i class="fa fa-check"></i> Active</span>
            <span class="label label-warning" v-else><i class="fa fa-warning"></i> {{ site.integrations.ip.status }}</span>
          </td>
        </tr>
        <tr v-if="site.integrations.ip.nameServers">
          <td>Dns</td>
          <td>
            {{ site.integrations.ip.nameServers.join(',') }}
            <span v-if="site.whois && site.integrations.ip.nameServers === site.whois.ns">
              <i class="fa fa-check-circle green" v-tooltip="'Nameservers pointed to CloudFlare'"></i>
            </span>
            <span v-else>
              <span v-if="user.admin && site.registrar && site.registrar.integration && site.registrar.integration.canUpdateNS">
                <a @click="setNs(site.integrations.ip.nameServers)"><i class="fa fa-upload pull-right" v-tooltip="'Point nameservers to CF'"></i></a>
              </span>
            </span>
          </td>
        </tr>
        <tr>
          <td>SSL</td>
          <td>
            <e-txt
              type="select"
              :selected-value="site.integrations.ip.settings && site.integrations.ip.settings.ssl ? site.integrations.ip.settings.ssl.value : '?'"
              :options="['off', 'flexible', 'full', 'strict']"
              :text="site.integrations.ip.settings && site.integrations.ip.settings.ssl && site.integrations.ip.settings.ssl.value ? site.integrations.ip.settings.ssl.value : '?'"
              @input="updateCfSettings('ssl', $event)"
              close-on-save="true"
              :locked="!user.admin"
            ></e-txt>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="2">
            <v-select :options="[{name: 'Random CF', id: 'random-cf'}].concat(f.ipProviders)" label="name" index="id" v-model="selectIpProvider"></v-select>
          </td>
        </tr>
        <tr v-if="selectIpProvider">
          <td colspan="2">
            <button class="btn btn-primary btn-xs" @click="assignIpProvider"><i class="fa fa-save"></i> Assign &amp; set up</button>
          </td>
        </tr>
        </tbody>
      </table>
        <table class="table table-striped" v-if="user.admin">
        <thead>
        <tr>
          <th colspan="2">
            Whois
            <a><i class="fa fa-refresh pull-right" v-tooltip="'Refresh Whois'" @click="refreshDns"></i></a>
          </th>
        </tr>
        </thead>
        <tbody v-if="site.whois && site.whois.registrar">
        <tr>
          <td>Registrar</td>
          <td>{{ site.whois.registrar }}</td>
        </tr>
        <tr>
          <td>Owner</td>
          <td>{{ site.whois.owner }}</td>
        </tr>
        <tr>
          <td>Nameservers</td>
          <td>
            {{ site.whois && site.whois.ns ? site.whois.ns.join(',')  : '' }}
            <a v-if="user.admin && site.registrar && site.registrar.integration && site.registrar.integration.canUpdateNS"><i class="fa fa-upload pull-right" title="Set Default Nameservers" v-tooltip="'Set Default Nameservers'" @click="setDefaultNs()"></i></a>
          </td>
        </tr>
        </tbody>
        <tbody v-if="false">
        <tr v-if="site.dnsData && site.dnsData.NS" v-for="(record, i) in site.dnsData.NS" :key="'dnsDataNS-' + i">
          <td>{{ record.type }}</td>
          <td>{{ record.target }}</td>
        </tr>
        <tr v-if="site.dnsData.A" v-for="(record, i) in site.dnsData.A" :key="'dnsDataA-' + i">
          <td>{{ record.type }}</td>
          <td>
            {{ record.ip }}
            <i
              v-if="site.integrations && site.integrations.hosting && site.integrations.hosting.ip.ip_address !== record.ip"
              class="fa fa-warning red"
              :title="'Expected IP: ' + site.integrations.hosting.ip.ip_address"></i>
            <i
              title="A Record matches Priority Prospect account"
              class="fa fa-check green"
              v-if="site.integrations && site.integrations.hosting && site.integrations.hosting.ip.ip_address === record.ip"></i>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="col-lg-4">
      <table class="table table-striped">
        <thead>
        <tr>
          <th colspan="2">Hosting</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td colspan="2">
            <e-txt
              :locked="!user.admin"
              type="select"
              :text="site.hosting ? site.hosting.name : ''"
              :options="f.hosts"
              select-value="id"
              select-label="name"
              :selected-value="site.hosting ? site.hosting.id : ''"
              :close-on-save="true"
              @input="updatePbn($event, 'hosting')"
            ></e-txt>
          </td>
        </tr>
        </tbody>
        <tbody v-if="site.hosting">
        <tr>
          <td>Url</td>
          <td><a :href="site.hosting.login.url" target="_blank">{{ shorten(site.hosting.login.url, 50) }}</a></td>
        </tr>
        <tr v-if="user.admin">
          <td>User</td>
          <td>
            <pass>
              <span slot="visible">
                {{ site.hosting.login.user }} <i class="fa fa-copy copy-clipboard pull-right" @click="copyToClipboard(site.hosting.login.user)"></i>
              </span>
            </pass>
          </td>
        </tr>
        <tr v-if="user.admin">
          <td>Password</td>
          <td>
            <pass>
              <span slot="visible">
              {{ site.hosting.login.pass }} <i class="fa fa-copy copy-clipboard pull-right" @click="copyToClipboard(site.hosting.login.pass)"></i>
              </span>
            </pass>
          </td>
        </tr>
        <tr v-if="site.integrations && site.integrations.hosting && site.integrations.hosting.hostingType">
          <td>Server</td>
          <td>
            <span v-if="site.integrations.hosting.hostingType === 'CUSTOM_HOST' || (site.hosting && site.hosting.id === '5f913275ced39178dcb06028')">
              <strong><span v-if="site.hosting.integration === 'priority-prospect'">Digital Ocean</span> {{ site.customData.doServer }}</strong>
              <span v-if="site.hostingPermission === 'locked'">
                <i class="fa fa-lock red" v-tooltip="'Edit Mode Off'"></i>
                <button class="btn btn-xs pull-right btn-primary" @click="changeHostingPermission('unlock')"><i class="fa fa-unlock"></i> Unlock</button>
              </span>
              <span v-else>
                <i class="fa fa-unlock green" v-tooltip="'Edit Mode Active'"></i>
                <button class="btn btn-xs pull-right btn-warning" @click="changeHostingPermission('lock')"><i class="fa fa-lock"></i> Lock</button>
              </span>
            </span>
            <span v-if="site.integrations.hosting.hostingType === 'SHARED_HOSTING'">
              <strong>Priority Prospect</strong>
              <button class="btn btn-warning btn-xs pull-right" @click="loginToCpanel"><i class="fab fa-cpanel"></i> Cpanel</button>
            </span>
          </td>
        </tr>
        <tr v-else-if="site.hosting.id === '5f913275ced39178dcb06028'">
          <td>
            <strong>Digital Ocean</strong>
            <span v-if="site.hostingPermission === 'locked'">
                <i class="fa fa-lock red" v-tooltip="'Edit Mode Off'"></i>
                <button class="btn btn-xs pull-right btn-primary" @click="changeHostingPermission('unlock')"><i class="fa fa-unlock"></i> Unlock</button>
              </span>
            <span v-else>
                <i class="fa fa-unlock green" v-tooltip="'Edit Mode Active'"></i>
                <button class="btn btn-xs pull-right btn-warning" @click="changeHostingPermission('lock')"><i class="fa fa-lock"></i> Lock</button>
              </span>
          </td>
        </tr>
        <tr v-if="site.hosting && site.hosting.lastImport">
          <td colspan="2">
            Refreshed: {{ site.hosting.lastImport | aTime('DD.MM. HH:mm') }}
          </td>
        </tr>
        </tbody>
      </table>
      <table class="table table-hover">
        <thead v-if="site.hosting">
        <tr>
          <th>
            Hosting data
          </th>
        </tr>
        <tr>
          <td>
            <component :is="site.hosting.integration" :site="site" :user="user"></component>
          </td>
        </tr>
        </thead>
        <thead v-else>
        <tr>
          <th>
            <i class="fa fa-warning orange"></i> Hosting not set
          </th>
        </tr>
        </thead>
      </table>
    </div>
  </div>
</template>
<script>
import EditText from '../../../../Helpers/Form/EditText'
import Form from '../../../../Helpers/Modal/Form'
import { mapGetters } from 'vuex'
import { Browser, Values } from '../../../../../mixins/helperMixin'
import axios from 'axios'
import { PBN_SET } from '../../../../../store/mutation-types'
import hidePassword from '../../../../Helpers/Form/hidePassword'
import PriorityProspect from './Build/Hosts/PriorityProspect'
import DigitalOcean from './Build/Hosts/DigitalOcean'

export default {
  data () {
    return {
      loginModal: {},
      selectIpProvider: null,
      regStageModal: {}
    }
  },
  computed: {
    ourHosting () {
      return (this.site.integrations && this.site.integrations.hosting && this.site.integrations.hosting.hostingType === 'CUSTOM_HOST') || (this.site.hosting && this.site.hosting.id === '5f913275ced39178dcb06028') || this.site.hasAphexManager
    },
    ...mapGetters({
      site: 'getPbn',
      user: 'getUser',
      f: 'getFilters'
    })
  },
  components: {
    eTxt: EditText,
    mForm: Form,
    pass: hidePassword,
    PriorityProspect,
    DigitalOcean
  },
  mixins: [Browser, Values],
  methods: {
    createStaging (userConfirmation = false) {
      if (userConfirmation) {
        if (!confirm('Reinstalling WP will wipe all existing data from staging! Are you sure you want to continue?')) {
          return
        } else {
          if (this.user.id === '62468b3eb6210f022e2c9172') {
            if (!confirm('Are you really dead fucking sure about it Dariusz? There\'s no going back from this!')) {
              return
            }
          } else if (this.user.id === '63f3543a24c6881ae57021d7') {
            if (!confirm('Alo bre, jel si siguran?')) {
              return
            }
          }
        }
      }
      axios.post('/pbn/site/' + this.site.punyDomain + '/staging?force=true')
        .then(r => {
          this.$toastr.success('Please wait a couple of seconds', 'Staging successfully ordered')
        })
        .catch(e => {
          this.$toastr.error(e, 'Error')
        })
    },
    updatePbn (val, opt) {
      let data = {}
      data[opt] = val
      axios.patch('/pbn/site/' + this.site.punyDomain, data).then(r => {
        this.$store.commit(PBN_SET, r.data.pbn)
      }).catch(e => {
        this.$toastr.error(e, 'Update failed')
      })
    },
    saveLogin (user = null, pass = null) {
      if (user && pass) {
        if (!confirm('Copy staging logins to production?')) {
          return
        }
      } else {
        if (!this.loginModal.username || !this.loginModal.password) {
          this.$toastr.error('Please enter username and password!', 'Data missing')
          return
        }
        user = this.loginModal.username
        pass = this.loginModal.password
      }
      axios.put('/pbn/site/' + this.site.punyDomain + '/login', {
        username: user,
        password: pass
      })
        .then(r => {
          this.$store.commit(PBN_SET, r.data.pbn)
          this.$toastr.success('Login successfully updated', 'Login added')
          $('#add-login').modal('hide')
          this.loginModal = {}
        })
        .catch(e => {
          this.$toastr.error(e, 'Login update issue')
        })
    },
    removeLogin (user) {
      if (!confirm('Remove username ' + user + ' from the database?')) {
        return
      }
      axios.delete('/pbn/site/' + this.site.punyDomain + '/login/' + user)
        .then(r => {
          this.$store.commit(PBN_SET, r.data.pbn)
          this.$toastr.success('Login successfully deleted', 'Login deleted')
        })
        .catch(e => {
          this.$toastr.error(e, 'Login removal failed')
        })
    },
    installAphexManager () {
      axios.post('/pbn/site/' + this.site.punyDomain + '/install/aphex-manager')
        .then(r => {
          if (r.data.success !== true) {
            this.$toastr.error('Failed :/', ':\'(')
            return
          }
          this.$toastr.success('Aphex Manager successfully installed', 'Success!!!')
          this.$store.commit(PBN_SET, r.data.pbn)
        })
        .catch(e => {
          this.$toastr.error(e, 'This was rather unsuccessful')
        })
    },
    refreshDns () {
      axios.post('pbn/site/' + this.site.punyDomain + '/imports/dns')
        .then(r => {
          this.$toastr.success('DNS records successfully imported', 'Way to go!')
          this.$store.commit(PBN_SET, r.data.pbn)
        })
        .catch(e => {
          this.$toastr.error(e, 'Something seems to have gone wrong...')
        })
    },
    reportIssue (issue, msg) {
      if (!confirm(`Report login issue for ${this.site.punyDomain}?`)) {
        return
      }
      this.updatePbn(false, 'accessible')
    },
    loginToCpanel () {
      axios.get(`/pbn/site/${this.site.punyDomain}/hosting/priority-prospect/cpanel-login`)
        .then(r => {
          let url = r.data.redirectUrl
          window.open(url, '_blank')
        })
    },
    changeHostingPermission (perm) {
      axios.put(`/pbn/site/${this.site.punyDomain}/hosting/${perm}`)
        .then(r => {
          this.$store.commit(PBN_SET, r.data.pbn)
          this.$toastr.success('Permission successfully updated', 'Success!')
        })
    },
    async assignIpProvider () {
      if (!this.site.customData.doServer) {
        this.$toastr.error('Please select the server first!')
        return
      }
      if (confirm('Do you want to assign the IP Provider?')) {
        let pbn = await axios.patch(`/pbn/site/${this.site.punyDomain}`, {
          ip: this.selectIpProvider
        })
        this.$store.commit(PBN_SET, pbn.data.pbn)
      }
    },
    async removeCf () {
      if (confirm('Are you sure you want to remove Cloudflare as IP Provider?')) {
        let pbn = await axios.patch(`/pbn/site/${this.site.punyDomain}`, {
          ip: null
        })
        this.$store.commit(PBN_SET, pbn.data.pbn)
        this.$toastr.success('Done as requested...', 'Very well then')
      }
    },
    async adminLogin (environment = 'prod') {
      let url = await axios.post(`/pbn/site/${this.site.punyDomain}/sso/session?env=${environment}`)
      window.open(`${url.data.url}`, '_blank')
    },
    async setDefaultNs () {
      let pbn = await axios.patch(`/pbn/site/${this.site.punyDomain}/registrar/ns`, {
        nameservers: 'default'
      })

      this.$store.commit(PBN_SET, pbn.data)
    },
    async setNs (ns) {
      let pbn = await axios.patch(`/pbn/site/${this.site.punyDomain}/registrar/ns`, {
        nameservers: ns
      })

      this.$store.commit(PBN_SET, pbn.data)
    },
    async updateCfSettings (prop, val) {
      try {
        let pbn = await axios.patch(`/pbn/site/${this.site.punyDomain}/ip-providers/cloudflare/${prop}`, {
          setting: val
        })
        this.$store.commit(PBN_SET, pbn.data)
        this.$toastr.success('Cloudflare setting successfully updated')
      } catch (e) {
        this.$toastr.error(e.response.data.msg, 'CF Update failed')
      }
    },
    async purgeCache () {
      try {
        axios.post(`/pbn/site/${this.site.punyDomain}/cache/purge`)
        this.$toastr.success('I guess that should be it then?')
      } catch (e) {}
    },
    async saveStageData () {
      try {
        await axios.put(`/pbn/site/${this.site.punyDomain}/staging`, this.regStageModal)
        $('#register-staging').modal('hide')
        this.regStageModal = {}
      } catch (e) {
        this.$toastr.error('My oh my')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Single/Tabs/Info.vue